// components/Footer.jsx
import React from "react";
import "./Footer.css";
import logoImage from "../image/kadaipos_logo_transparent.png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleScroll = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* Top section */}
        <div className="footer__top">
          <div className="footer__brand">
            <img
              src={logoImage}
              alt="KadaiPOS"
              className="footer__logo"
              onClick={() => navigate("/")}
            />
            <p>
              The ultimate cloud-based POS solution for restaurants, cafes,
              bakeries & food businesses. Simplify operations, boost revenue.
            </p>
            <div className="footer__social">
              <a href="#" aria-label="Facebook" className="footer__social-link">
                <i className="fab fa-facebook-f" />
              </a>
              <a href="#" aria-label="Twitter" className="footer__social-link">
                <i className="fab fa-twitter" />
              </a>
              <a href="#" aria-label="Instagram" className="footer__social-link">
                <i className="fab fa-instagram" />
              </a>
              <a href="#" aria-label="LinkedIn" className="footer__social-link">
                <i className="fab fa-linkedin-in" />
              </a>
            </div>
          </div>

          <div className="footer__links-group">
            <h4>Product</h4>
            <a href="#features" onClick={(e) => handleScroll(e, "features")}>
              Features
            </a>
            <a href="#pricing" onClick={(e) => handleScroll(e, "pricing")}>
              Pricing
            </a>
            <a
              href="#testimonials"
              onClick={(e) => handleScroll(e, "testimonials")}
            >
              Testimonials
            </a>
            <a href="#faq" onClick={(e) => handleScroll(e, "faq")}>
              FAQ
            </a>
          </div>

          <div className="footer__links-group">
            <h4>Outlets</h4>
            <a onClick={() => navigate("/restaurantfeature")}>Restaurant</a>
            <a onClick={() => navigate("/coffeefeature")}>Cafe</a>
            <a onClick={() => navigate("/bakeryfeature")}>Bakery</a>
            <a onClick={() => navigate("/cloudkitchenfeature")}>
              Cloud Kitchen
            </a>
            <a onClick={() => navigate("/icecreamfeature")}>Ice Cream</a>
            <a onClick={() => navigate("/foodcourtfeature")}>Food Court</a>
          </div>

          <div className="footer__links-group">
            <h4>Company</h4>
            <a href="mailto:info@shanthitech.com">info@shanthitech.com</a>
            <a href="tel:+918124888145">+91 8124888145</a>
            <a href="#contact" onClick={(e) => handleScroll(e, "contact")}>
              Contact Us
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="footer__divider" />

        {/* Bottom */}
        <div className="footer__bottom">
          <p>© 2025 KadaiPOS by Shanthi Tech. All rights reserved.</p>
          <div className="footer__bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
